/* eslint-disable @typescript-eslint/no-explicit-any */

// Type definitions for cookieconsent
interface CookieConsentOptions {
  palette: {
    popup: {
      background: string;
    };
    button: {
      background: string;
      text: string;
    };
  };
  type: 'opt-out' | 'opt-in';
  content: {
    allow: string;
    deny: string;
    href: string;
  };
  autoAttach: boolean;
}

interface CookieConsentPopup {
  element: HTMLElement;
}

interface CookieConsent {
  Popup: new (options: CookieConsentOptions) => CookieConsentPopup;
}

declare global {
  interface Window {
    cookieconsent: CookieConsent;
  }
}

/**
 * Initialize cookie consent popup
 * This replaces the inline script from index.html
 */
export const initializeCookieConsent = () => {
  // Wait for cookieconsent to be available on window
  if (!window.cookieconsent) {
    console.warn('cookieconsent not loaded');
    return;
  }

  const consentCookieValue = document.cookie
    ?.split('; ')
    ?.find(cookie => cookie.includes('cookieconsent_status'))
    ?.split('=')?.[1];

  // Don't show popup if consent already given
  if (consentCookieValue) {
    return;
  }

  const cookieConsentOptions: CookieConsentOptions = {
    palette: {
      popup: {
        background: '#223348',
      },
      button: {
        background: '#22bbe8',
        text: '#223348',
      },
    },
    type: 'opt-out',
    content: {
      allow: 'Allow cookies',
      deny: 'Decline',
      href: 'https://uploads-ssl.webflow.com/61a7855f888fcb808709254f/638f54e17806493171904d0a_Ecoplant - Privacy Policy - Clean version December 6%2C 2022(12663247.10).docx',
    },
    autoAttach: false,
  };

  const instance = new window.cookieconsent.Popup(cookieConsentOptions);
  if (instance?.element) {
    document.body.appendChild(instance.element);
  }
};
